import { render, staticRenderFns } from "./applicationOutsourcing.vue?vue&type=template&id=ac982da2&lang=html&"
import script from "./applicationOutsourcing.vue?vue&type=script&lang=js&"
export * from "./applicationOutsourcing.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "applicationOutsourcing.vue"
export default component.exports